import {
  createComponentExtension,
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';

import { rootRouteRef } from './routes';

export const referenceDocsPlugin = createPlugin({
  id: 'reference-docs',
  routes: {
    root: rootRouteRef,
  },
});

export const ReferenceDocsPage = referenceDocsPlugin.provide(
  createRoutableExtension({
    name: 'ReferenceDocsPage',
    component: () =>
      import('./components/ReferenceDocsComponent').then(
        m => m.ReferenceDocsComponent,
      ),
    mountPoint: rootRouteRef,
  }),
);

export const ApiDocsComponent = referenceDocsPlugin.provide(
  createComponentExtension({
    name: 'ApiDocsComponent',
    component: {
      lazy: () =>
        import('./components/ApiDocsComponent').then(m => m.ApiDocsComponent),
    },
  }),
);
